import React from 'react';
import '../styles/MedicosDropdown.css';

const MedicosDropdown = ({ visible, activeTab, onTabClick }) => {
  const handleClick = (e, tab) => {
    e.preventDefault();
    onTabClick(tab);
  };

  return (
    <div className={`medicos-dropdown ${visible ? 'visible' : ''}`}>
      <div className="dropdown-content">
        <button
          className={`dropdown-tab ${activeTab === 'congresos' ? 'active' : ''}`}
          onClick={e => handleClick(e, 'congresos')}
        >
          Congresos
        </button>
        <button
          className={`dropdown-tab ${activeTab === 'noticias' ? 'active' : ''}`}
          onClick={e => handleClick(e, 'noticias')}
        >
          Últimas Noticias
        </button>
      </div>
    </div>
  );
};

export default MedicosDropdown;
